import React, {useContext, useEffect, useMemo, useState} from 'react';
import {Context} from '../../../../Helpers/Auth';
import {useTranslation} from 'react-i18next';
import SelectComponent from '../../../Selects/SelectComponent';
import MultiSelect from '../../../Selects/MultiSelect';

function Pagamento({editarProposta,descricaoOutros,setDescricaoOutros, arrayCondicoesPagamento, setCondicoesPagamento, condicoesPagamento, setOnChangeForm, setValidacaoCondicoesPagamento, validacaoCondicoesPagamento}) {
    const {t} = useTranslation();
    console.log(condicoesPagamento, 'aqui');
    return (
        <form className="mt-4">
            <div>
                <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    {t('condicoesPagamento')}*
                </label>
                <SelectComponent
                    isDisabled={!editarProposta}
                    options={arrayCondicoesPagamento}
                    value={condicoesPagamento}
                    onChange={e => {
                        setCondicoesPagamento(e);
                        setValidacaoCondicoesPagamento(false);
                        setOnChangeForm(true);
                    }}
                    noOptionsMessage={t('semopcoes')}
                    placeholder={t('selecioneOpcao')}
                />
                {validacaoCondicoesPagamento ? <small className="text-red-500">{t('preenchaCampos')}</small> : null}
            </div>
            {condicoesPagamento?.ativo && (
                <div className="mt-3">
                    <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                        {t('descricao')}
                    </label>
                    <textarea
                        disabled={!editarProposta}
                        id="message"
                        rows="1"
                        maxLength={250}
                        value={descricaoOutros}
                        onChange={e => {
                            setOnChangeForm(true);
                            setDescricaoOutros(e.target.value);
                            // setValidacaoDesc(false);
                        }}
                        className={`block p-2.5 w-full text-sm text-gray-900  rounded-[8px] border border-gray-300 focus:ring-blue-500 focus:border-blue-500  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500  ${
                            !editarProposta ? 'bg-gray-50 dark:bg-gray-800' : 'bg-white dark:bg-gray-900'
                        }`}
                        placeholder={t('escrevaDescricao')}></textarea>
                </div>
            )}
        </form>
    );
}

export default Pagamento;
